import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Redirect } from 'react-router-dom';
import { ContentWrapper, Panel, BackButton, ButtonType } from '@checkmarx/cx-ui';
import classNames from 'classnames';
import PrivateRouteWrapper from '../../router/privateRouteWrapper';
import PortalToastrContainer from '../../portal/portalToastrContainer';
import ConfirmationDialog from '../../portal/dialogs/confirmationDialog';
import EditRoleFormContainer from './form';
import styles from './style.scss';

@inject('translationsStore', 'rolesStore', 'permissionsStore',
    'serviceProvidersStore') @observer
export default class EditRoleContainer extends Component {
  
    t = this.props.translationsStore;
    rolesStore = this.props.rolesStore;
    permissionsStore = this.props.permissionsStore;
    serviceProvidersStore = this.props.serviceProvidersStore;

    state = {
        backToRolesScreen: false,
        openLeaveFormDialog: false
    };

    componentDidMount() {

        this.props.rolesStore.getRole(this.props.match.params.id)
            .then(role => {

                this.rolesStore.setName(role.name);
                this.rolesStore.setDescription(role.description);
                this.rolesStore.setPermissionIds(role.permissionIds);             
            });

        this.permissionsStore.getAllPermissions();
        this.serviceProvidersStore.getAllServiceProviders();
    }

    openLeaveFormDialogHandler = () => {

        this.setState({ 
            openLeaveFormDialog: true,
        });
    }
    
    stayFormDialogHandler = () => {

        this.setState({ 
            openLeaveFormDialog: false
        });
    }

    leaveFormDialogHandler = () => {

        this.setState({ 
            openLeaveFormDialog: false,
            backToRolesScreen: true
        });
    }

    backToRolesScreen = _ => {

        this.openLeaveFormDialogHandler();
    }

    cancelHandler = _ => {

        this.openLeaveFormDialogHandler();
    }

    componentWillUnmount() {

        this.rolesStore.resetForm();
        this.permissionsStore.resetPermissions();
        this.serviceProvidersStore.resetServiceProviders();
    }

    render() {
        
        const editRole = this.props.rolesStore.editRole;
        const permissions = this.permissionsStore.permissions;
        const authenticationProviders = this.serviceProvidersStore.serviceProviders;

        if (editRole === undefined 
                || permissions === undefined
                || permissions.length === 0
                    || authenticationProviders === undefined
                    || authenticationProviders.length === 0) {

            return null;
        }

        if(this.state.backToRolesScreen === true) {
            
            return <Redirect to='/roles' />;
        }

        return (
            <PrivateRouteWrapper>
                <ContentWrapper
                    className={styles.rolesContentWrapper}
                >
                    <Panel className={styles.rolesContentLeftHand}>
                        <PortalToastrContainer />
                        <div className={styles.settingTitle}>
                            <BackButton
                                dataCy='back-to-roles-main-screen'
                                onClick={this.backToRolesScreen}
                                text={this.t.translate('BACK')}
                                title={this.t.translate('BACK')}
                            />
                        </div>
                        <div
                            className={classNames(styles.roleName, 'ellipsis')}
                            title={editRole.name}
                        >
                            {editRole.name}
                        </div>
                        <div
                            className={styles.editRoleInfo}
                        >
                            {this.t.translate('UPDATE_ROLE_NAME_AND_DESCRIPTION')}
                        </div>
                    </Panel>
                    <Panel className={styles.rolesContentRightHand}>
                        <div className={styles.rolesContentBody}>
                            <EditRoleFormContainer
                                id={this.props.match.params.id}
                                editRole={editRole}
                                cancelHandler={this.cancelHandler}
                                permissions={permissions}
                                authenticationProviders={authenticationProviders}
                            />
                        </div>
                        <ConfirmationDialog 
                            open={this.state.openLeaveFormDialog}
                            onButtonClick={this.stayFormDialogHandler}
                            onCancelClick={this.leaveFormDialogHandler}
                            closeClick={this.stayFormDialogHandler}
                            buttonText={this.t.translate('STAY')}
                            cancelButtonText={this.t.translate('LEAVE')}
                            titleText={this.t.translate('CONFIRMATION')}
                            contentText={this.t.translate('ARE_YOU_SURE_YOU_WANT_TO_LEAVE_THIS_FOR_WITHOUT_SAVING')}
                        />
                    </Panel>
                </ContentWrapper>
            </PrivateRouteWrapper>
    )
  }
}
